export default {
  haulers: 'Transportistas',
  setup: 'Configuración',
  driverExperience: 'Experiencia del conductor',
  users: 'Usuarios',
};
